import { useCallback } from 'react'

import { IconX, Tag, TransparentIconButton, WithTooltip } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from '../../messages'

export interface IReportAccessGrantTagProps {
  grantId: number
  removeButtonId: string
  userFullName: string
  isHighlighted: boolean
  onRemove: (grantId: number) => void
}

export const ReportAccessGrantTag = ({
  grantId,
  removeButtonId,
  userFullName,
  isHighlighted,
  onRemove,
}: IReportAccessGrantTagProps) => {
  const intl = useProcurifyIntl()

  const handleRemoveClick = useCallback(
    () => onRemove(grantId),
    [onRemove, grantId]
  )

  return (
    <WithTooltip title={userFullName} placement='top'>
      <Tag
        bgcolor={isHighlighted ? 'primary' : undefined}
        color={isHighlighted ? 'textInverse' : undefined}
        icon={
          <TransparentIconButton
            type='button'
            id={removeButtonId}
            aria-label={intl.formatMessage(messages.removeGrantLabel, {
              userFullName,
            })}
            iconComponent={<IconX />}
            iconColor={isHighlighted ? 'textInverse' : undefined}
            onClick={handleRemoveClick}
          />
        }
      >
        {userFullName}
      </Tag>
    </WithTooltip>
  )
}

ReportAccessGrantTag.displayName = 'ReportAccessGrantTag'
